import { MessageCircle } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export default function WhatsAppButton() {
  const { language } = useLanguage();
  const phoneNumber = "34627183220";
  const messages: Record<string, string> = {
    es: 'Hola%20Dra.%20Raquel%20Molina%2C%20me%20gustar%C3%ADa%20programar%20una%20consulta.',
    en: 'Hello%20Dr.%20Raquel%20Molina%2C%20I%20would%20like%20to%20schedule%20a%20consultation.',
    sv: 'Hej%20Dr.%20Raquel%20Molina%2C%20jag%20skulle%20vilja%20boka%20en%20konsultation.',
  };
  const titles: Record<string, string> = {
    es: 'Chatear por WhatsApp',
    en: 'Chat on WhatsApp',
    sv: 'Chatta på WhatsApp',
  };
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${messages[language]}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-lg transition-all hover:scale-110 hidden md:flex items-center justify-center"
      title={titles[language]}
    >
      <MessageCircle className="h-6 w-6" />
    </a>
  );
}
